// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"4fc16065f4b88d300e45","785":"2717ec30aee917472a57"}[chunkId] + ".js";
};